// extracted by mini-css-extract-plugin
export default {"container":"style_container__h5YUc","tabWrapper":"style_tabWrapper__NWRmI","contentWrapper":"style_contentWrapper__6mlPz","buttonWrapper":"style_buttonWrapper__zyRkR"};